// extracted by mini-css-extract-plugin
module.exports = {"clubEmailAddedAttachments":"ClubEmailAttachments_clubEmailAddedAttachments__1YSX8"};